import styles from './PlacingOrderAddressDropdownItem.module.scss';
import DelIcon from '@assets/icons/del-grey-12.svg';
import { ButtonIcon } from '@components/ButtonIcon';
import { IPlacingOrderAddressDropdownItemProps } from '../../types';

const PlacingOrderAddressDropdownItem: React.FC<IPlacingOrderAddressDropdownItemProps> = (props: IPlacingOrderAddressDropdownItemProps): React.ReactElement => {
  const { item, handlerGetFullAddress, handlerOnClickDeleteAddress } = props;

  return (
      <div className={styles.address}>
        {handlerGetFullAddress(item, 'renderItem')}
        {!!item.id.length && (
            <ButtonIcon
                className={styles.addressAction}
                icon={DelIcon}
                onClick={() => handlerOnClickDeleteAddress(item.id)}
            />
        )}
      </div>
  );
};

export default PlacingOrderAddressDropdownItem;